import React from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineExternalLink } from 'react-icons/hi';

interface MdlCardProps {
    title: string;
    subtitle?: string;
    href?: string;
    accent?: 'blue' | 'green' | 'purple' | 'gray';
    children: React.ReactNode;
}

const ACCENT: Record<string, string> = {
    blue: 'border-blue-300 bg-blue-50/40',
    green: 'border-green-300 bg-green-50/40',
    purple: 'border-purple-300 bg-purple-50/40',
    gray: 'border-gray-300 bg-gray-50/40',
};

const HEADER_ACCENT: Record<string, string> = {
    blue: 'bg-blue-100 text-blue-900',
    green: 'bg-green-100 text-green-900',
    purple: 'bg-purple-100 text-purple-900',
    gray: 'bg-gray-100 text-gray-800',
};

const MdlCard: React.FC<MdlCardProps> = ({ title, subtitle, href, accent = 'blue', children }) => (
    <div className={`rounded-lg border ${ACCENT[accent]} shadow-sm overflow-hidden`}>
        <div className={`px-3 py-2 ${HEADER_ACCENT[accent]}`}>
            {href ? (
                <Link to={href} className="group inline-flex items-center gap-1 font-bold text-sm hover:underline" title="Abrir">
                    {title}
                    <HiOutlineExternalLink size={13} className="opacity-50 group-hover:opacity-100" />
                </Link>
            ) : (
                <div className="font-bold text-sm">{title}</div>
            )}
            {subtitle && <div className="text-[11px] font-mono opacity-70">{subtitle}</div>}
        </div>
        <div className="p-3 bg-white dark:bg-slate-800">{children}</div>
    </div>
);

export default MdlCard;
